import { TimeRecord } from '@/types';
import { calculateMonthStats, formatMinutes } from '@/lib/calendar';
import { Clock, Calendar, TrendingUp } from 'lucide-react';

interface CalendarStatsProps {
  records: TimeRecord[];
}

export function CalendarStats({ records }: CalendarStatsProps) {
  const stats = calculateMonthStats(records);

  const statItems = [
    {
      label: '総稼働時間',
      value: `${stats.totalHours}h`,
      subValue: formatMinutes(stats.totalMinutes),
      icon: Clock,
      color: 'from-blue-500 to-blue-600',
    },
    {
      label: '稼働日数',
      value: `${stats.workDays}日`,
      subValue: '',
      icon: Calendar,
      color: 'from-green-500 to-green-600',
    },
    {
      label: '平均稼働時間/日',
      value: formatMinutes(stats.avgMinutesPerDay),
      subValue: '',
      icon: TrendingUp,
      color: 'from-purple-500 to-purple-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {statItems.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.label}
            className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">{item.label}</p>
                <p className="text-3xl font-bold text-gray-800">{item.value}</p>
                {item.subValue && (
                  <p className="text-sm text-gray-500 mt-1">{item.subValue}</p>
                )}
              </div>
              <div
                className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center`}
              >
                <Icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
